import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Table
} from "reactstrap";
import i18n from "../../../i18n";
import SimpleAlertError from '../../../components/Alerts/SimpleAlertError';
import { useDispatch } from "react-redux";
import { postServicesAssignAdmin } from "../../../helpers/api_rombo_helper";
import Paginations from "../../../components/Common/Pagination";
import Spinners from "../../../components/Common/Spinner";
import Select from "react-select";
import { map } from "lodash";
import { WebsocketDrivers } from "./WebsocketDrivers";
import { useNavigate } from 'react-router-dom';
import { DataActions, DriverStatus, BookingType } from "../../../constants/enums";

const Step2 = ({ step, setStep, token, infoUser, services, setServices, servicesError, setServicesError }) => {

  const dispatch = useDispatch();
  const history = useNavigate();
  const [errorAlert, setErrorAlert] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [listDrivers, setListDrivers] = useState({ items: [] });
  const [formatDrivers, setFormatDrivers] = useState([]);
  const [newPlates, setNewPlates] = useState([]);
  const [servicesSuccess, setServicesSuccess] = useState(true);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [serviceType, setServiceType] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = services.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(services.length / recordsPerPage);
  const [filtersOpts, setFiltersOpts] = useState({
    eventType: "sendMessage",
    metadata: { platform: "WEB" },
    data: { action: DataActions.GET_DRIVERS, filters: { page: 1, size: 10, status: DriverStatus.ALL } }
  });
 
  useEffect(() => {
    let arr = [];
    let platesServices = services.map((e) => e.plate);
    listDrivers.items.map((item) => !platesServices.includes(item.vehicle.plate) && arr.push({ label: item.vehicle.plate, value: item.vehicle.plate, sub: item.driver.sub }));
    setFormatDrivers([...arr]);
  }, [listDrivers]);
  
  useEffect(() => {
    let flag = false;
    services.map((item) => item.subDriver ? null : flag = true);
    setServicesSuccess(flag);
  }, [services]);

  const onClickNextStep = () => {
    let body = { assigns: newPlates.map((item) => ({ sub: item.subDriver, plate: item.plate, code: item.code })) };
    setNewPlates([]);
    postServicesAssignAdmin(token, body)
      .then((resp) => {
        let flag = true;
        let arr = [];
        services.map((item) => {
          let itemResp = resp.assigns.filter((e) => e.code == item.code).shift();
          if (itemResp) {
            if (itemResp.status == "SUCCESSFUL") {
              item.disabled = true;
              item.className = "bg-green text-white rounded-2 text-center p-1 fs-10";
              item.textContent = i18n.t("Assigned");
            } else {
              flag = false;
              item.disabled = false;
              item.className = "bg-red text-white rounded-2 text-center p-1 fs-10";
              item.textContent = i18n.t("Unassigned");
            }
          }
          arr.push(item);
        });
        setServices([...arr]);
        if (flag) {
          setServicesError(false);
        }
      })
      .catch((error) => {
        console.error("Error - postServicesAssignAdmin - ", error);
        if (error.code == 500) setErrorAlertMessage(i18n.t("ServerError"));
      });
  };

  const onClickFinish = () => {
    localStorage.setItem("notify", "true");
    localStorage.setItem("headerText", i18n.t("ServiceAlertSuccessHeader"));
    localStorage.setItem("bodyText", i18n.t("ServiceAlertSuccessBody"));
  
    if (infoUser?.is_staff) {
      history("/services/general");
    } else {
      history("/services/assignment");
    }
  };
  
  const onChangePlate = (service, e) => { 
    let onServices = services;
    let onNewPlates = newPlates;
    let onFormatDrivers = formatDrivers;
    let onService = services.filter((item) => service.code == item.code).shift();
    if (onService.plate) onFormatDrivers.push({ label: onService.plate, value: onService.plate, sub: onService.subDriver });
    onServices.splice(onServices.indexOf(onService), 1);
    onService.plate = e.value;
    onService.subDriver = e.sub;
    onService.nameDirver = e.sub;
    onServices.push(onService);
    onNewPlates.push(onService);
    onServices.sort((a, b) => a.code.localeCompare(b.code));
    let onFormatDriver = onFormatDrivers.filter((item) => e.value == item.value).shift();
    onFormatDrivers.splice(onFormatDrivers.indexOf(onFormatDriver), 1);
    setFormatDrivers([...onFormatDrivers]);
    setNewPlates([...onNewPlates]);
  };

  return (
    <Fragment>
      <CardBody>
        <SimpleAlertError
          errorAlert={errorAlert}
          setErrorAlert={setErrorAlert}
          text={errorAlertMessage}
        />
        <Row>
          <Col xxl={6} md={6} xs={12}>
            <h5>{i18n.t("RequestsToBeAssigned")}</h5>
            <p>{i18n.t("RequestsAssignedDesc")}</p>
            <h6>{i18n.t("RequestsAssignedDesc2", { number: services.length })}</h6>
          </Col>
          <div className="table-responsive pt-3 relative overflow-x-auto shadow-md sm:rounded-lg">
            <Table className="table table-responsive border table-assignment-services">
              <thead>
                <tr>
                  <th className="bg-light request-number-column">{i18n.t("ID")}</th>
                  <th className="bg-light origin-column">{i18n.t("Origin")}</th>
                  <th className="bg-light destination-column">{i18n.t("Destiny")}</th>
                  <th className="bg-light date-column">{i18n.t("Date")}</th>
                  <th className="bg-light hour-column">{i18n.t("Hour")}</th>
                  <th className="bg-light status-column">{i18n.t("Status")}</th>
                  <th className="bg-light plates-column">{i18n.t("Plate")}</th>
                </tr>
              </thead>
              {isLoading ? null : (
                <tbody>
                  {map(currentRecords, (item, key) => (
                    <tr key={key}>
                      <td>{item.code}</td>
                      <td>{item.origin.address.description}</td>
                      <td>
                        {serviceType === BookingType.CLOSED ? item.destination.address.description : ""}
                      </td>
                      <td>{item.scheduled_start.date}</td>
                      <td>{item.scheduled_start.time}</td>
                      <td>
                        <p className={`${item.className}`}>{`${item.textContent}`}</p>
                      </td>
                      <td>
                        <Card>
                          <Select
                            name="plate"
                            placeholder={i18n.t("NotAssigned")}
                            options={formatDrivers}
                            isDisabled={item.disabled}
                            className="select2-selection"
                            onChange={(e) => onChangePlate(item, e)}
                            value={{
                              label: item.plate,
                              value: item.plate,
                              sub: item.subDriver,
                            }}
                            maxMenuHeight={200}
                          />
                        </Card>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              nPages > 1 && (
                <Paginations
                  perPageData={recordsPerPage}
                  data={services}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  isShowingPageLength={false}
                  paginationDiv="col-lg-12"
                  paginationClass="pagination pagination-rounded justify-content-center mt-3 mb-4 pb-1"
                />
              )
            )}
          </div>
          <WebsocketDrivers
            setLoading={setLoading}
            filtersOpts={filtersOpts}
            uuid={infoUser.external_id}
            listDrivers={listDrivers}
            setListDrivers={setListDrivers}
          />
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            {servicesError ? (
              <button
                onClick={() => onClickNextStep()}
                disabled={newPlates.length === 0}
                className="btn btn-users"
              >
                {i18n.t("Finished")}
              </button>
            ) : (
              <button onClick={() => onClickFinish()} className="btn btn-users">
                {i18n.t("Finished")}
              </button>
            )}
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  );
};

export default Step2;
